import { render } from "./UserStatusSelect.vue?vue&type=template&id=5ccfec0d&ts=true"
import script from "./UserStatusSelect.vue?vue&type=script&lang=ts"
export * from "./UserStatusSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__